import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { 
    Box,
    Button,
    Input,
    Text 
} from '@chakra-ui/react';
import { WCRestAPI, WPRestAPI } from 'src/services/api/ApiService';

interface LabelProps {
    text: string;
}

const Label: React.FC<LabelProps> = ({ text }) => {
    return (
        <Text fontSize="1.2rem" fontWeight="bold" color="#1d6973" >
            {text}
        </Text>
    );
};

export const WasteCollectionEntryPoint = () => {
    const [userInput, setUserInput] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const navigateToStorePage = async () => {
        const userId = userInput;
        setIsLoading(true);
        WCRestAPI.get(`/customers?search=${userId}`)
            .then(() => navigate(`/noutotilaus/${userId}`))
            .catch(() => navigate(`/noutotilaus/unregistered`))
            .finally(() => setIsLoading(false));
    }

    const navigateToUnregisteredPage = () => {
        navigate(`/noutotilaus/unregistered`);
    }

    return (
        <Box display="flex" justifyContent="center" backgroundColor="lightgray" height="60vh">
            <Box maxWidth="90%">
                <Box>
                    <Text fontSize="2.25rem" fontWeight="bold" marginTop="2rem" marginBottom="1rem">
                        Pickup order for used batteries and small batteries and SER products
                    </Text>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    padding="3rem 4rem"
                    gap="1rem"
                    backgroundColor="white"
                    borderRadius="30px"
                >
                    <Label text="Enter your collection point number (ID):"/>
                    <Box display="flex" gap="1rem" marginBottom="2rem" flexDirection={{ base: "column", md: "row" }}>
                        <Input 
                            type="text"
                            width={{ base: "100%", md:"250px" }} 
                            padding="20px"
                            border="1px solid black"
                            borderRadius="15px"
                            focusBorderColor="#1d6973"
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                        />
                        <Button 
                            variant="solid"
                            backgroundColor="#1d6973"
                            borderRadius="15px"
                            border="1px solid #1d6973"
                            color="white"
                            fontWeight="normal"
                            padding="20px"
                            _hover={{ backgroundColor: "#17545c" }}
                            _disabled={{ opacity: 0.65, cursor: "auto" }}
                            isDisabled={userInput.length === 0 || isLoading}
                            onClick={navigateToStorePage}
                        >
                            Continue
                        </Button>
                    </Box>
                    <Label text="Or continue as an unregistered collection point:"/>
                    <Button 
                        variant="outline"
                        width={{ base: "100%", md: "8rem" }}
                        borderRadius="15px"
                        border="1px solid #1d6973"
                        color="#1d6973"
                        fontWeight="normal"
                        padding="20px"
                        _hover={{ backgroundColor: "#1d6973", color: "white" }}
                        onClick={navigateToUnregisteredPage}
                        isDisabled={isLoading}
                    >
                        Continue
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};